// @mui
import { useTheme } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
// theme
import { bgBlur } from 'src/theme/css';
import { useLocation } from 'react-router-dom'; //  NEW
// routes
import { paths } from 'src/routes/paths';
// hooks
import { useOffSetTop } from 'src/hooks/use-off-set-top';
// components
import Logo from 'src/components/logo';
import { RouterLink } from 'src/routes/components';
//
import { Box } from '@mui/system';
import { HEADER } from '../config-layout';
import HeaderShadow from './header-shadow';
import SettingsButton from './settings-button';

// ----------------------------------------------------------------------

export default function HeaderSimple() {
  const theme = useTheme();
  const location = useLocation();
  const isForgotPassword = location.pathname === paths.auth.jwt.forgotPassword;
  const isChangePassword = location.pathname === paths.auth.jwt.changePassword;
  const offsetTop = useOffSetTop(HEADER.H_DESKTOP);

  return (
    <AppBar
      elevation={0}
      sx={{
        bgcolor: 'background.default',
        backgroundImage: 'none',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderBottom: 1,
        borderColor: 'divider',
        // eslint-disable-next-line no-shadow
        boxShadow: (theme) => theme.customShadows?.z8,

        transition: theme.transitions.create(['backdrop-filter', 'height'], {
          duration: theme.transitions.duration.shorter,
        }),

        ...(offsetTop && {
          ...bgBlur({
            color: theme.palette.background.default,
          }),
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
        }),
      }}
    >
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          height: {
            xs: HEADER.H_MOBILE,
            md: HEADER.H_DESKTOP,
          },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...(offsetTop && {
            ...bgBlur({
              color: theme.palette.background.default,
            }),
            height: {
              md: HEADER.H_DESKTOP_OFFSET,
            },
          }),
        }}
      >
        <Logo sx={{ width: 160, height: 'auto', cursor: 'pointer' }} />

        <Stack direction="row" alignItems="center" spacing={1}>
          <SettingsButton />

          {!isForgotPassword && isChangePassword && (
            <Link
              href={paths.faqs}
              component={RouterLink}
              color="inherit"
              sx={{ typography: 'subtitle2' }}
            >
              Need help?
            </Link>
          )}
        </Stack>
      </Toolbar>

      {offsetTop && <HeaderShadow />}
    </AppBar>
  );
}
